import React, { useState } from "react";
import { Modal, StyleSheet, Text, View } from "react-native";
import Icon from "react-native-vector-icons/MaterialCommunityIcons";
import * as Colors from "../styles/colors";
import * as Fonts from "../styles/typography";
import Button from "./Button";
import CaixaTextoInputIcone from "./TextBoxIcon";

export default function TicketKeyboard({
  modalVisible,
  setModalVisible,
  navigation
}) {
  const [qrCode, setQrCode] = useState(null);
  
  const sendQrCode = (qrCode) => {
    navigation.navigate("PaymentTicket", qrCode);
  };

  return (
    <Modal
      animationType="fade"
      transparent={true}
      style={{ backgroundColor: "#000" }}
      visible={modalVisible}
      onRequestClose={() => setModalVisible(!modalVisible)}
    >
      <View style={styles.centeredView}>
        <View style={styles.modalView}>
          <Icon
            name="close"
            size={32}
            onPress={() => {
              setModalVisible(!modalVisible);
            }}
            style={styles.closeButton}
          />
          <View style={styles.titleView}>
            <Text style={styles.titleText}>{"Digite a placa ou o ticket"}</Text>
          </View>
          <View style={styles.subTitleView}>
            <CaixaTextoInputIcone
              iconName={"ticket-confirmation-outline"}
              placeholderInput={"AAA1A11 ou 9999999"}
              onChangeTextInput={(qrCode) => setQrCode(qrCode)}
              value={qrCode}
              styleBox={{ width: 250, marginTop: 16 }}
            />
          </View>
          <View style={styles.viewButton}>
            <Button
              textoBotao={"Confirmar"}
              estilo={{ backgroundColor: Colors.SUCCESS, marginLeft: 16 }}
              onPress={() => sendQrCode(qrCode)}
            />
          </View>
        </View>
      </View>
    </Modal>
  );
}

const styles = StyleSheet.create({
  centeredView: {
    flex: 1,
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: "rgba(0,0,0,0.5)",
  },
  titleView: {
    marginBottom: 8,
    alignItems: "center",
  },
  titleText: {
    textAlign: "center",
    fontSize: Fonts.FONT_SIZE_18,
  },
  subTitleView: {
    alignItems: "center",
  },
  subTitleText: {
    textAlign: "center",
    fontSize: Fonts.FONT_SIZE_16,
    color: Colors.GRAY_DARK,
  },
  modalView: {
    margin: 20,
    backgroundColor: Colors.WHITE,
    borderRadius: 8,
    padding: 16,
    alignItems: "center",
    shadowColor: "#000",
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowOpacity: 0.25,
    shadowRadius: 4,
    elevation: 5,
  },
  closeButton: {
    marginLeft: "auto",
    color: Colors.GRAY_DARK,
  },
  viewButton: {
    marginTop: 16,
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
  },
  amountText: {
    fontSize: Fonts.FONT_SIZE_24,
    color: Colors.BLACK,
    fontWeight: "500",
  },
});
